<div class="w-100 register-panel rounded-0">
  <div class="overflow-hidden p-0 register-panel rounded-0">
    <div
      class="row login-banner"
      [style.background-image]="'url(' + ('login-registration/login-background.png' | contentAssetImage) + ')'"
    >
      <div class="d-flex d-lg-none justify-content-center mt-3" [class.bg-corporate-primary]="isCorporate">
        <img
          [src]="'logos/logo.svg' | contentAssetImage"
          width="50"
          height="50"
          draggable="false"
          *inPopulation="[populations.Membership]"
        />
        <img
          width="50"
          height="50"
          [src]="'logos/kid-logo.png' | contentAssetImage"
          draggable="false"
          *inPopulation="[populations.JuniorBluebirds]"
        />
        <img
          width="50"
          height="50"
          [src]="'logos/corporate-logo.png' | contentAssetImage"
          draggable="false"
          *inPopulation="[populations.Hospitality]"
        />
      </div>
      <div class="d-none d-lg-flex justify-content-center align-items-center mt-lg-5">
        <img
          width="100"
          height="100"
          [src]="'logos/logo.svg' | contentAssetImage"
          draggable="false"
          *inPopulation="[populations.Membership]"
        />
        <img
          width="100"
          height="100"
          [src]="'logos/kid-logo.png' | contentAssetImage"
          draggable="false"
          *inPopulation="[populations.JuniorBluebirds]"
        />
        <img
          width="100"
          height="100"
          [src]="'logos/corporate-logo.png' | contentAssetImage"
          draggable="false"
          *inPopulation="[populations.Hospitality]"
        />
      </div>
      <div class="user-login-panel text-start">
        <div class="container">
          <div class="user-login-row row bg-white py-4 px-2">
            <div class="col-12">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
